import * as React from 'react';
import { Helper } from '../../Helper';
import { Environment } from '../../services/Environment';
import { IAIcon } from '../icon/Icon';
import * as styles from './CroppedImage.css';

export interface IACroppedImageProps {
  token?: string;
  tenant?: string;
  environment?: "Development" | "Test" | "Production";
  marginTop?: number;
  minHeight?: number;
  showLoadingSpinner?: boolean;
  imageSrc: string;
  crop: { x: number, y: number, width: number, height: number };
  modified?: string;
}

export interface IACroppedImageState {
  loading: boolean;
}

export class IACroppedImage extends React.Component<IACroppedImageProps, IACroppedImageState> {
  constructor(props: IACroppedImageProps) {
    super(props);

    this.state = {
      loading: true,
    }
  }

  render(){
    var imageSrcSL = this.props.imageSrc;
    imageSrcSL = imageSrcSL.replace("DefaultRendition", "StandardLarge");
    imageSrcSL = imageSrcSL.replace("Full", "StandardLarge");
    imageSrcSL = imageSrcSL.replace("StandardSmall", "StandardLarge");
    imageSrcSL = imageSrcSL.replace("Square", "StandardLarge");
    imageSrcSL = imageSrcSL.replace("Wide", "StandardLarge");
    imageSrcSL = imageSrcSL.replace("Original", "StandardLarge");
    
    let imageProxy:string = Helper.getImageUrl(Environment.getEnvironmentForImageAPI(this.props.environment), this.props.tenant, this.props.token, imageSrcSL, this.props.modified ? this.props.modified : undefined, "StandardLarge", this.props.crop, false);

    let minHeight = this.props.minHeight ?? 50;

    return (
      <div
        className={styles.IACroppedImage_Container}
        style={{ minHeight: minHeight }}
      >
        { this.props.showLoadingSpinner && this.state.loading && 
          <div 
            className={styles.IACroppedImage_Loading}
            style={{ minHeight: minHeight }}
          >
            <div 
              className={styles.IACroppedImage_Spinner}
              style={{ marginTop: this.props.marginTop, }}
            >
              <IAIcon
                title="Spinner"
                size={40}
                color={"#aaaaaa"}
              />
            </div>
          </div>
        }
        <img
          className={styles.IACroppedImage_Image}
          style={{ marginTop: this.props.marginTop, display: this.state.loading ? "none" : "inline" }}
          src={imageProxy}
          onLoad={() => this.setState({ loading: false })}
        />
      </div>
    );
  }
}
